const Container = ({ children, className = "" }) => {
  return (
    <div className={`container-first ${className}`}>
      {children}
    </div>
  );
};

export default Container;
